import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {useSelector, useDispatch} from 'react-redux';
import CustomButton from '../CustomButton';
import * as AC from '../../actions';

const DeleteModal = () => {
  const dispatch = useDispatch();
  const {modalProps} = useSelector(s => s.modal);
  const {adminsLoading} = useSelector(s => s.admins);
  const {buildingsLoading} = useSelector(s => s.buildings);
  const {entrancesLoading} = useSelector(s => s.entrances);
  const {garagesLoading, customerGaragesLoading} = useSelector(s => s.garages);

  const loading =
    adminsLoading ||
    buildingsLoading ||
    entrancesLoading ||
    garagesLoading ||
    customerGaragesLoading;

  const onClose = () => {
    dispatch(AC.closeModal());
  };

  const onDelete = () => {
    switch (modalProps.type) {
      case 'admin':
        return dispatch(AC.deleteAdmin(modalProps.item.id));
      case 'supervisor':
        return dispatch(AC.deleteSupervisor(modalProps.item.id));
      case 'complex':
        return dispatch(AC.deleteBuilding(modalProps.item.id));
      case 'entrance':
        return dispatch(AC.deleteEntrance(modalProps.item.id));
      case 'card':
        return dispatch(AC.deleteCard(modalProps.item.id));
      case 'elevator':
        return dispatch(AC.deleteElevator(modalProps.item.id));
      case 'customer':
        return dispatch(AC.deleteCustomer(modalProps.item.id));
      case 'garage':
        return dispatch(
          AC.deleteGarage(modalProps.item.id, modalProps.item.buildingId),
        );
      case 'customerGarage':
        return dispatch(
          AC.deleteCustomerGarage(
            modalProps.item.id,
            modalProps.item.customerId,
          ),
        );
      default:
        return null;
    }
  };

  const name = () => {
    switch (modalProps.type) {
      case 'admin':
      case 'customer':
        return `${modalProps.item.firstName} ${modalProps.item.lastName}`;
      case 'card':
        return 'this ';
      case 'customerGarage':
        return 'data';
      default:
        return modalProps.item.name;
    }
  };

  return (
    <>
      <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
        Are you sure you want to delete
      </Typography>
      <Typography alignSelf="center" variant="h6" fontWeight="bold">
        {modalProps.type === 'card' && name()}
        {modalProps.type} {modalProps.type !== 'card' && name()}
      </Typography>
      <Box display="flex" mt="2rem" gap="1rem">
        <CustomButton onClick={onClose} sx={{flex: 1}} variant="outlined">
          Cancel
        </CustomButton>
        <CustomButton loading={loading} onClick={onDelete} sx={{flex: 1}}>
          Delete
        </CustomButton>
      </Box>
    </>
  );
};

export default DeleteModal;
